import { DISMISS, useNotification } from "collections";
import { useFeatureFlagWithTenant } from "elements";
import {
  ExternalPolicyQueryVariables,
  useExternalPolicyQuery
} from "generated/graphql";
import { useTranslation } from "utilities/i18n";
import { useEffect } from "react";

const useFeatureControlledExternalPolicyQuery = (
  variables: ExternalPolicyQueryVariables,
  pause: boolean
) => {
  const [isTACIntegrationEnabled] = useFeatureFlagWithTenant("TAC_INTEGRATION");

  return useExternalPolicyQuery({
    variables,
    pause: pause || !isTACIntegrationEnabled
  });
};
export const useExternalPolicy = ({
  checkExternalPolicy,
  tenantId,
  deviceId
}: {
  checkExternalPolicy: boolean;
  tenantId: string;
  deviceId?: string;
}) => {
  const { t } = useTranslation();
  const [addNotification] = useNotification();

  const {
    data: externalPolicyData,
    fetching: fetchingExternalPolicy
  } = useFeatureControlledExternalPolicyQuery(
    {
      tenantId,
      deviceId
    },
    !checkExternalPolicy
  );

  const externalPolicy = externalPolicyData?.getPolicies?.[0];

  useEffect(() => {
    if (
      checkExternalPolicy &&
      !fetchingExternalPolicy &&
      externalPolicy &&
      externalPolicy.lastSuccessfullyUpdated === false
    ) {
      addNotification({
        id: "external-policy-error",
        type: "error",
        message: t("EXTERNAL_DEVICE_POLICY_FAILED"),
        dismiss: DISMISS.SLOW,
        persistThroughNav: true
      });
    }
    // omit t and addNotification from deps, otherwise causes useEffect to call infinitely with no usefulness
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkExternalPolicy, fetchingExternalPolicy, externalPolicy]);

  return {
    fetching: fetchingExternalPolicy,
    policy: externalPolicy
  };
};
